
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_modules.scss';
import '../styles/pages/_emotio-psycho-rational-resources.scss';
import { DollarSign, PiggyBank, CreditCard } from 'lucide-react';

const financialWellnessImage = require('../assets/Financial.png');

const modules = [
  {
    id: 'm1',
    title: 'Budgeting for Filipinos',
    icon: <DollarSign size={24} />,
    link: '/panel/financial-planning/module-1',
  },
  {
    id: 'm2',
    title: 'Saving & Investing',
    icon: <PiggyBank size={24} />,
    link: '/panel/financial-planning/module-2',
  },
  {
    id: 'm3',
    title: 'Debt Management',
    icon: <CreditCard size={24} />,
    link: '/panel/financial-planning/module-3',
  },
];

const FinancialPlanningResourcePage: React.FC = () => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();

  return (
    <div className={`resources-page ${isDarkMode ? 'dark' : ''}`}> 
      <div className="module-resources_container">
        {/* Header Section */}
        <div className="module-resources_header">
          <div className="module-resources_header-content">
            <div className="module-resources_header-text">
              <h2>Financial Planning Resources</h2>
            </div>
          </div>
        </div>

        {/* Modules Grid */}
        <div className="module-resources_modules">
          <div className="module-resources_modules-grid">
            {modules.map((module) => (
              <div
                key={module.id}
                className="module-resources_module-card"
                onClick={() => navigate(module.link)}
                role="button"
                tabIndex={0}
                onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    navigate(module.link);
                  }
                }}
              >
                <div className="module-resources_module-image">
                  <img src={financialWellnessImage} alt={module.title} />
                </div>
                <div className="module-resources_module-content">
                  <h3 className="module-resources_module-title">{module.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialPlanningResourcePage;

